





































































import type { BtnType } from '@/constants/ux-constants'
import { Vue, Component, Prop, Model } from 'vue-property-decorator'

@Component({
  components: {
    SmBtn: () => import('@/components/atoms/SmBtn.vue'),
    SmText: () => import('@/components/atoms/SmText.vue'),
    SmBtnText: () => import('@/components/atoms/SmBtnText.vue'),
  }
})
export default class SmDialogClosableSimpleRepairPlanRegistration extends Vue {
  @Prop({ required: true, default: '' })
  private readonly title!: string

  @Prop({ default: 'キャンセル' })
  private readonly cancelBtnLabel!: string

  @Prop({ default: false })
  private readonly disableCancelBtn!: boolean

  @Prop()
  private readonly executionBtnLabel?: string

  @Prop()
  private readonly executionBtnType?: BtnType

  @Prop()
  private readonly deleteBtnLabel?: string

  @Prop()
  private readonly deleteBtnType?: BtnType

  @Prop()
  private readonly disableDeleteBtn?: boolean

  @Prop()
  private readonly isSelectedPeriod?: boolean

  @Prop()
  private readonly height?: string

  @Prop({ default: false })
  private readonly isSelectedItemStyle!: boolean

  @Model('change')
  private isVisible!: boolean

  private get contentStyle():string {
    let style = ''
    style += this.height ? `height:${this.height}` : ''
    return style
  }
}
